<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block w-full mx-3 md:w-1/2 md:mx-auto max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded overflow-y-scroll"
              style="height: 70vh"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-2 px-5 md:px-8">
                <h2 class="text-xl text-brand-black">Application History</h2>
              </div>

              <div class="px-5 md:px-8 max-h-100 overflow-y-scroll">
                <div v-for="(logs, date) in history" :key="date" class="py-3">
                  <h5 class="py-1 text-brand-blue">{{ date }}</h5>

                  <div class="border border-brand-mid-gray w-full my-2"></div>

                  <div
                    v-for="(log, index) in logs"
                    :key="log.timestamp"
                    class="flex flex-row py-2 px-2"
                    :class="[(index + 1) % 2 === 0 ? 'bg-brand-light-gray' : 'bg-white']"
                  >
                    <div class="flex items-center w-1/3">
                      {{ formatTime(log.timestamp) }}
                    </div>

                    <div class="flex flex-col w-2/3">
                      <template v-if="log.object === 'application' && log.type === 'user_action'">
                        <p v-if="log.extra_data.action !== 'refund'">
                          User {{ log.extra_data.username }}
                          {{
                            log.extra_data.action[log.extra_data.action.length - 1] === "e"
                              ? `${log.extra_data.action}d`
                              : `${log.extra_data.action}ed`
                          }}
                          the application.
                        </p>
                        <p v-if="log.extra_data.action === 'refund'">
                          Refund processed for ${{ log.extra_data.data.amount }}.
                        </p>
                      </template>
                      <template v-if="log.object === 'report' && log.type === 'status_change'">
                        <p>
                          {{ log.report_type }} report status updated to {{ log.extra_data.to }}.
                        </p>
                      </template>
                      <template v-if="log.type === 'mail'">
                        <p>
                          Email sent to {{ log.extra_data.to.join(",") }} with subject:
                          {{ log.extra_data.subject }}
                        </p>
                        <template v-if="log.extra_data.reject_reasons">
                          <p class="text-xs">Reject reasons: {{ log.extra_data.reject_reasons }}</p>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

import moment from "moment"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    app: {
      type: Object
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    history() {
      if (this.app) {
        const formatted = {}

        const logs = JSON.parse(JSON.stringify(this.app.audit_logs))

        logs.map((log) => {
          const created = moment(log.timestamp)

          if (!formatted[created.format("MM-DD-YYYY")]) {
            formatted[created.format("MM-DD-YYYY")] = []
          }

          //Skip status_change
          if (log.type === "status_change") {
            return
          }

          formatted[created.format("MM-DD-YYYY")].push(log)
        })
        return formatted
      } else {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit("close")
    },
    formatTime(date) {
      return `${moment(date).format("h:mma")} CST`
    }
  }
}
</script>
<style scoped></style>
